import { render, staticRenderFns } from "./BulkCategory.vue?vue&type=template&id=ccc03258&scoped=true"
import script from "./BulkCategory.vue?vue&type=script&lang=ts"
export * from "./BulkCategory.vue?vue&type=script&lang=ts"
import style0 from "./BulkCategory.vue?vue&type=style&index=0&id=ccc03258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc03258",
  null
  
)

export default component.exports